import * as React from 'react';
import { ProgressContainer, BackgroundProgressBar, ProgressBarIndicator } from './Style/LoadingBar.styled';

export const LoadingBar = () => (
    <ProgressContainer>
        <BackgroundProgressBar>
            <ProgressBarIndicator />
        </BackgroundProgressBar>
    </ProgressContainer>
)